import { HStack } from '@/components/ui/hstack';
import { Skeleton } from '@/components/ui/skeleton';
import { VStack } from '@/components/ui/vstack';

/** The most comment rows drawn, however many the post has. */
const MAX_COMMENT_ROWS = 3;

/**
 * The comments section while it loads: rows when the post has comments, the
 * empty state's footprint when it has none, nothing when the count is unknown.
 */
export function CommentsSkeleton({ commentCount }: { commentCount?: number }) {
  if (commentCount === undefined) {
    return null;
  }

  if (commentCount === 0) {
    return (
      <VStack
        testID="library-comments-empty-loading"
        className="flex-1 items-center justify-center gap-4 bg-background-50 px-5 py-10">
        <Skeleton className="h-6 w-40" />

        <Skeleton className="h-4 w-44" />
      </VStack>
    );
  }

  return (
    <VStack className="px-5 pb-2 pt-6">
      <Skeleton className="mb-6 h-7 w-32" />

      {[...Array(Math.min(commentCount, MAX_COMMENT_ROWS))].map((_, index) => (
        <HStack key={index} testID="library-comment-loading" className="mb-6 gap-3">
          <Skeleton className="h-9 w-9" variant="circular" />

          <VStack className="flex-1 gap-2">
            <Skeleton className="h-4 w-40" />

            <Skeleton className="h-3 w-28" />

            <Skeleton className="mt-2 h-4 w-full" />

            <Skeleton className="h-4 w-4/5" />

            <HStack className="mt-1 gap-6">
              <Skeleton className="h-4 w-8" />

              <Skeleton className="h-4 w-12" />
            </HStack>
          </VStack>
        </HStack>
      ))}
    </VStack>
  );
}
